<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<div class="box error" v-if="!currentUser.admin">
  <h2> {{ $t('access-denied') }} </h2>
  <p>{{ $t('insufficient-permission') }}</p>
</div>
<div class="page-wrapper content-wrapper" v-else>
  <div class="panel">
    <div style="width: 100%;">
      <div class="content-title-wrapper">
        <label class="hierarchy-label">{{ $t('admin') }}</label>
        <div>
          <button
            v-for="tab in tabNames"
            :key="tab"
            @click="changeTab(tab)"
            :class="['tab-button', { active: activeTab === tab }]"
          >
            {{ $t(tab === 'extern' ? 'external-service' : tab) }}
          </button>
        </div>
      </div>
      <hr class="hr-style" />

      <div class="content-body-wrapper">
        <keep-alive>
          <component :is="activeComponent" />
        </keep-alive>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {get} from '@/utils/store-helpers';

import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
// import AdminExternalService from './AdminExternalService';
import AdminTags from './AdminTags';
const defaultTab = 'dashboard';

export default {
  name: 'admin-panel',
  data() {
    return {
      activeTab: 0,
      tabNames: [
        'dashboard',
        'users',
        'tags',
        // 'extern'
      ]
    };
  },
  computed: {
    currentUser: get('currentUser/user'),
    queriedTab() {
      return this.$route.query.tab;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    activeComponent() {
      switch(this.activeTab) {
        case 'dashboard':
          return AdminDashboard;
        case 'users':
          return AdminUsers;
        // case 'extern':
        //   return AdminExternalService;
        case 'tags':
          return AdminTags;
      }
      throw new Error('Cannot load active tabs ' + this.activeTab);
    }
  },
  watch: {
    queriedTab() {
      this.changeTabFromQuery();
    },
    activeTab() {
      const currentTab = this.$route.query.tab || defaultTab;
      if (this.activeTab !== currentTab) {
        this.$router.push(`?tab=${this.activeTab}`).catch(() => {});
      }
    }
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;
      const currentTab = this.$route.query.tab || defaultTab;
      if (this.activeTab !== currentTab) {
        this.$router.push(`?tab=${this.activeTab}`).catch(() => {});
      }
    },
    changeTabFromQuery() {
      this.activeTab = this.queriedTab || defaultTab;
      if(!this.activeComponent) {
        this.activeTab = defaultTab;
      }
    }
  },
  async created() {
    this.changeTabFromQuery();
  }
};
</script>

<style scoped>
.page-wrapper {
  vertical-align: middle !important;
  height: 100%;
}

.content-wrapper {
  padding: 0 2.5%;
  position: relative;
  min-height: 100%;
  overflow: hidden;
}

.content-title-wrapper {
  height: 75px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.hierarchy-label {
  margin: 18px 10px;
  font-size: 1.3rem;
  color: #4A4847;
}

.tab-button {
  all: unset;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  cursor: pointer;
}

.tab-button.active {
  color: #009BDB;
  border-bottom: 3px solid #009BDB;
}

.content-body-wrapper {
  height: calc(100vh - 75px);
  overflow: auto;
}

.hr-style {
  margin: 0;
}

.panel {
  display: flex;
  flex-direction: row;
}

.box.error {
  position: relative;
  min-height: 20em;
}
</style>
